import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IconDownLoad from '../../Icons/IconDownload';
import IconPorcentaje from '../../Icons/IconPorcentaje';
import CompraService from '../../services/CompraService';
import { useAuthStore as useAuthStoreEroski } from '../../store/AuthContext';
import useAPIError from '../../hooks/useAPIError';
import { FileDownloadHelper } from '../../store/FileDownloadHelper';
import { PriceFormatter } from '../../utils/PriceFormatter';
import { HostProvider } from '../../utils/HostProvider';

type Props = {
  data: {
    ingresoEroskiClub: number;
    ingresoEroskiClubOro: number;
    otrosDescuentos: number;
    idTicket: number;
    ahorroTicket: number;
  };
  isTicketDownloadable: boolean;
};

const ExpandedRow: FC<Props> = ({ data, isTicketDownloadable }) => {
  const { t } = useTranslation();
  const dataUser = useAuthStoreEroski();
  const { moneda } = dataUser.user;
  const { addError } = useAPIError();
  const isEroski = HostProvider.isEroski();
  const DownLoadTicket = () => {
    CompraService.ticketDownload(data.idTicket)
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
        } else {
          const fileName = t('compras.ticketFileName');
          FileDownloadHelper.downloadFile(response, fileName);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
      });
  };

  const DownLoadDetalleCompra = () => {
    CompraService.detalleCompraDownload(data.idTicket)
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
        } else {
          const fileName = t('compras.compraFileName');
          FileDownloadHelper.downloadFile(response, fileName);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'ERROR');
      });
  };

  const priceFormatter = (cell: any) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return PriceFormatter.formatStringAsPrice(cell as string, monedaText);
  };

  return (
    <>
      <td colSpan={5} className={`detalle-fila__container-${data.idTicket}`}>
        <div className="detalle-fila__content">
          {(() => {
            return (
              <>
                <span className="detalle__lugar">
                  {t('compras.savingByShopping')}
                </span>
                {(() => {
                  return (
                    <>
                      <div className="ahorro">
                        {/* eslint-disable-next-line jsx-a11y/alt-text */}
                        <div className="ahorro__title">
                          {/* eslint-disable-next-line jsx-a11y/alt-text */}
                          <img
                            className="img"
                            src={
                              isEroski
                                ? '../../assets/images/tarjeta-eroski-club-m-2.png'
                                : '../../assets/images/tarjeta-caprabo-m.png'
                            }
                            alt=""
                          />
                          <span className="title">
                            {' '}
                            {isEroski
                              ? t('compras.incomeEroskiClub')
                              : t('caprabo.compras.incomeEroskiClub')}
                          </span>
                        </div>
                        <span className="ahorro__num ok">
                          {priceFormatter(data.ingresoEroskiClub)}
                        </span>
                      </div>
                    </>
                  );
                })()}

                {(() => {
                  if (data.ingresoEroskiClubOro !== 0) {
                    return (
                      <>
                        <div className="ahorro">
                          <div className="ahorro__title">
                            {/* eslint-disable-next-line jsx-a11y/alt-text */}
                            <img
                              alt=""
                              className="img"
                              src="../../assets/images/tarjetaOro.png"
                            />
                            <span className="title">
                              {t('compras.incomeEroskiClub')}
                            </span>
                          </div>
                          <span className="ahorro__num ok">
                            {priceFormatter(data.ingresoEroskiClubOro)}
                          </span>
                        </div>
                      </>
                    );
                  }
                  return false;
                })()}

                {(() => {
                  if (data.otrosDescuentos !== 0) {
                    return (
                      <>
                        <div className="ahorro">
                          <div className="ahorro__title">
                            <IconPorcentaje classCss="display-block" />
                            <span className="title">{t('compras.others')}</span>
                          </div>
                          <span className="ahorro__num ok">
                            {priceFormatter(data.ingresoEroskiClubOro)}
                          </span>
                        </div>
                      </>
                    );
                  }
                  return false;
                })()}
              </>
            );
          })()}

          <div className="enlaces">
            {isTicketDownloadable ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                href="#"
                onClick={() => {
                  DownLoadTicket();
                }}
              >
                <span>{t('compras.downloadTicket')}</span>
                <div className="icon icon--brand icon-medium">
                  <IconDownLoad />
                </div>
              </a>
            ) : (
              ''
            )}
            {isEroski ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                href="#"
                onClick={() => {
                  DownLoadDetalleCompra();
                }}
              >
                <span>{t('compras.downloadCompra')}</span>
                <div className="icon icon--brand icon-medium">
                  <IconDownLoad />
                </div>
              </a>
            ) : (
              ''
            )}
          </div>
        </div>
      </td>
    </>
  );
};

export default ExpandedRow;
